import { render, staticRenderFns } from "./UserAccessTable.vue?vue&type=template&id=4522892c&scoped=true"
import script from "./UserAccessTable.vue?vue&type=script&lang=js"
export * from "./UserAccessTable.vue?vue&type=script&lang=js"
import style0 from "./UserAccessTable.vue?vue&type=style&index=0&id=4522892c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4522892c",
  null
  
)

export default component.exports